import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import {
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlinePrinter,
} from "react-icons/ai";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Modal from "../../components/Modal";
import Invoice from "../../components/Invoice";
// import DatePicker from "../../components/DatePicker";
import NoData from "../../components/Nodata";

import useStore from "../../store";

import api from "../../services/api";

export default () => {
  const [payments, setPayments] = useState();
  const [filters, setFilters] = useState({
    startDate: new Date(new Date().setDate(1)),
    endDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
  });

  const { user } = useStore();

  useEffect(() => {
    getPayments();
  }, [filters]);

  const getPayments = async (e) => {
    try {
      const { data } = await api.post("payment/search", filters);
      setPayments(data.payments);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (payment) => {
    try {
      if (!window.confirm("Are you sure ?")) return;
      const { data } = await api.remove(`payment&id=${payment.id}`);
      await getPayments();
      toast.success("Successfully deleted !");
    } catch (e) {
      console.log(e);
    }
  };

  if (!payments) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="p-5">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Payments</h1>
        <button
          title="Print all payments"
          onClick={() => window.print()}
          className="print:hidden cursor-pointer bg-orange-500 hover:bg-orange-700 text-white p-2.5 rounded flex items-center disabled:cursor-progress"
        >
          <AiOutlinePrinter className="text-xl mr-2" />
          <span className="text-sm">Print</span>
        </button>
      </div>

      <div className="grid grid-cols-3 gap-4 my-4 print:hidden">
        <input
          type="search"
          placeholder="Search by customer name"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          className="block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
          required
        />

        <DatePicker
          selected={filters.startDate}
          value={new Date(filters.startDate).toLocaleDateString([], {
            month: "long",
          })}
          onChange={(startDate) => {
            const date = new Date(startDate);
            setFilters({
              ...filters,
              startDate: new Date(startDate.setDate(1)),
              endDate: new Date(date.setMonth(date.getMonth() + 1)),
            });
          }}
          className="cursor-pointer block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
          showMonthYearPicker
          calendarClassName="bg-white border border-gray-200 shadow-lg rounded-lg p-2"
        />
      </div>

      <div className="bg-white shadow-lg rounded-lg p-6">
        <table className="w-full text-left border-collapse my-5">
          <thead className="text-sm text-gray-400 border-b">
            <tr>
              <th className="py-2">Customer</th>
              <th className="py-2">Description</th>
              <th className="py-2">Amount</th>
              <th className="py-2">Created By</th>
              <th className="py-2">Date</th>
              <th className="py-2 text-right print:hidden">Actions</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {payments.map((payment) => (
              <tr
                className="hover:bg-gray-50 border-b"
                // onClick={() => navigate(`/payment/${payment.id}`)}
              >
                <td className="p-2 py-3">{payment.customer_name}</td>
                <td className="p-2 py-3">
                  {payment.type !== "Other"
                    ? payment.type
                    : payment.description}
                </td>
                <td className="p-2 py-3">
                  {payment.amount.toLocaleString()} PKR
                </td>
                <td className="p-2 py-3">{payment.created_by || "admin"}</td>
                <td className="p-2 py-3">
                  {new Date(payment.created_at).toLocaleDateString()}
                </td>
                <td className="print:hidden">
                  <div className="flex justify-end">
                    {/* <UpdatePayment
                    payment={payment}
                    onChange={getPayments}
                    customer={customer}
                  />
                  <ViewInvoice
                    payment={payment}
                    customer={customer}
                    totalAmount={totalAmount}
                    paidAmount={paidAmount}
                  /> */}
                    {user.role === "admin" && (
                      <button
                        title="Delete"
                        onClick={async () => await handleDelete(payment)}
                        className="cursor-pointer bg-red-500 hover:bg-red-700 text-white p-2.5 rounded ml-1 print:hidden"
                      >
                        <AiOutlineDelete />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!payments?.length && <NoData />}
      </div>
    </div>
  );
};

const ViewInvoice = ({ payment, customer, paidAmount, totalAmount }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        title="View Invoice"
        onClick={() => setIsOpen(true)}
        className="cursor-pointer bg-orange-500 hover:bg-orange-700 text-white p-2.5 rounded"
      >
        <AiOutlinePrinter />
      </button>

      <Modal
        title="Invoice"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        className="max-w-3xl"
      >
        <Invoice
          customer={customer}
          payment={payment}
          totalAmount={totalAmount}
          paidAmount={paidAmount - payment.amount}
        />

        <div className="mt-6 flex justify-end print:hidden">
          <button
            onClick={() => window.print()}
            className="cursor-pointer bg-orange-500 hover:bg-orange-700 text-white p-2.5 rounded flex items-center space-x-2"
          >
            <AiOutlinePrinter className="text-lg" /> <span>Print</span>
          </button>
        </div>
      </Modal>
    </>
  );
};

const CreatePayment = ({ customer, onChange }) => {
  const [values, setValues] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  const { user } = useStore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      values.created_by = user.username;
      values.customer_id = customer.id;
      values.customer_name = customer.name;
      await api.post("payment", values);
      await onChange();
      toast.success("Created!");
      setValues({});
      setIsOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="flex justify-end">
        <button
          onClick={() => setIsOpen(true)}
          className="text-sm text-blue-600 underline"
        >
          Create new payment
        </button>
      </div>

      <Modal
        title="Create new payment"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <form onSubmit={handleSubmit}>
          {/* Section 1: Personal Details */}
          <div className="grid gap-6">
            <div>
              <label
                htmlFor="type"
                className="block text-sm font-medium text-gray-700"
              >
                Payment type
              </label>
              <select
                id="type"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                value={values.type}
                onChange={(e) =>
                  setValues({
                    ...values,
                    type: e.target.value,
                    description: e.target.value,
                  })
                }
              >
                <option value="">Select</option>
                {customer?.services?.map((service) => (
                  <option value={service.name}>{service.name}</option>
                ))}
                <option value="Other">Other</option>
              </select>
              {customer?.services?.find((s) => s.name === values.type) && (
                <p className="text-xs mt-2 text-gray-500">
                  Service fee:{" "}
                  {customer?.services
                    ?.find((s) => s.name === values.type)
                    .fee.toLocaleString()}{" "}
                  PKR
                </p>
              )}
            </div>

            {values.type === "Other" && (
              <div>
                <label
                  htmlFor="description"
                  className="block text-sm font-medium text-gray-700"
                >
                  Description
                </label>
                <input
                  type="text"
                  id="description"
                  value={values.description}
                  onChange={(e) =>
                    setValues({ ...values, description: e.target.value })
                  }
                  placeholder="Enter description"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
            )}
            <div>
              <label
                htmlFor="amount"
                className="block text-sm font-medium text-gray-700"
              >
                Amount
              </label>
              <input
                type="number"
                id="amount"
                value={values.amount}
                onChange={(e) =>
                  setValues({ ...values, amount: e.target.value })
                }
                placeholder="Enter amount"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                required
              />
            </div>
            <div>
              <label
                htmlFor="method"
                className="block text-sm font-medium text-gray-700"
              >
                Payment Method
              </label>
              <select
                id="method"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                value={values.method}
                onChange={(e) =>
                  setValues({ ...values, method: e.target.value })
                }
              >
                <option value="">Select</option>
                <option value="ONLINE">Online</option>
                <option value="CASH">Cash</option>
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex items-center space-x-2 mt-5">
            <button
              type="submit"
              className="bg-black text-sm text-white px-6 py-2 rounded-md hover:bg-gray-900 transition"
            >
              Submit
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

const UpdatePayment = ({ payment, onChange, customer }) => {
  const [values, setValues] = useState(payment);
  const [isOpen, setIsOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("payment", values);
      await onChange();
      toast.success("Updated!");
      setIsOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <button
        title="Edit"
        onClick={() => setIsOpen(true)}
        className="cursor-pointer bg-blue-500 hover:bg-blue-700 text-white p-2.5 rounded mr-1"
      >
        <AiOutlineEdit />
      </button>

      <Modal
        title="Update payment"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <form onSubmit={handleSubmit}>
          {/* Section 1: Personal Details */}
          <div className="grid gap-6">
            <div>
              <label
                htmlFor="type"
                className="block text-sm font-medium text-gray-700"
              >
                Payment type
              </label>
              <select
                id="type"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                value={values.type}
                onChange={(e) =>
                  setValues({
                    ...values,
                    type: e.target.value,
                    description: e.target.value,
                  })
                }
              >
                <option value="">Select</option>
                {customer?.services?.map((service) => (
                  <option value={service.name}>{service.name}</option>
                ))}
                <option value="Other">Other</option>
              </select>
              {customer?.services?.find((s) => s.name === values.type) && (
                <p className="text-xs mt-2 text-gray-500">
                  Service fee:{" "}
                  {customer?.services
                    ?.find((s) => s.name === values.type)
                    .fee.toLocaleString()}{" "}
                  PKR
                </p>
              )}
            </div>

            {values.type === "Other" && (
              <div>
                <label
                  htmlFor="description"
                  className="block text-sm font-medium text-gray-700"
                >
                  Description
                </label>
                <input
                  type="text"
                  id="description"
                  value={values.description}
                  onChange={(e) =>
                    setValues({ ...values, description: e.target.value })
                  }
                  placeholder="Enter description"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
            )}
            <div>
              <label
                htmlFor="amount"
                className="block text-sm font-medium text-gray-700"
              >
                Amount
              </label>
              <input
                type="number"
                id="amount"
                value={values.amount}
                onChange={(e) =>
                  setValues({ ...values, amount: e.target.value })
                }
                placeholder="Enter amount"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                required
              />
            </div>
            <div>
              <label
                htmlFor="method"
                className="block text-sm font-medium text-gray-700"
              >
                Payment Method
              </label>
              <select
                id="method"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                value={values.method}
                onChange={(e) =>
                  setValues({ ...values, method: e.target.value })
                }
              >
                <option value="">Select</option>
                <option value="ONLINE">Online</option>
                <option value="CASH">Cash</option>
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex items-center space-x-2 mt-5">
            <button
              type="submit"
              className="bg-black text-sm text-white px-6 py-2 rounded-md hover:bg-gray-900 transition"
            >
              Submit
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};
